// src/utils/roles.js  (new helper)
export const OFFICE_ROLE = {
    "DIAMOND-META": "shipper",
    "Pawsitively":  "carrier"
  };
  
  export const getRole = (officeCode) => OFFICE_ROLE[officeCode] || "other";
  
  export const PERMS = {
    shipper: {
      canCreate: false,
      canApprove: true,
      canReject:  true,
      canRecall:  false,
      canSeeRejected: false,
    },
    carrier: {
      canCreate: true,
      canApprove: false,
      canReject:  false,
      canRecall:  true,
      canSeeRejected: true,
    },
    other: {
      canCreate: false,
      canApprove: false,
      canReject:  false,
      canRecall:  false,
      canSeeRejected: false,
    }
  };
  